import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Energyflat } from './energyflat.model';
import { EnergyflatService } from './energyflat.service';

@Component({
    selector: 'jhi-energyflat-detail',
    templateUrl: './energyflat-detail.component.html'
})
export class EnergyflatDetailComponent implements OnInit, OnDestroy {

    energyflat: Energyflat;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private energyflatService: EnergyflatService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['energyflat']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInEnergyflats();
    }

    load(id) {
        this.energyflatService.find(id).subscribe((energyflat) => {
            this.energyflat = energyflat;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInEnergyflats() {
        this.eventSubscriber = this.eventManager.subscribe('energyflatListModification', (response) => this.load(this.energyflat.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/energyflat/energyflat-detail.component.ts